import { Component } from '@angular/core';
import { Menu, NavmenuService } from '../../services/navmenu.service';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { LayoutService } from '../../services/layout.service';
import { CommonModule } from '@angular/common';
import { FeathericonComponent } from '../feathericon/feathericon.component';
import { NgbModule, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';
import { TranslateModule } from '@ngx-translate/core';
import { ApiCallsService } from '../../services/api-calls.service';
import { FormsModule } from '@angular/forms';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { debounceTime, distinctUntilChanged, map, Subject } from 'rxjs';
import { environment } from '../../../../environments/environment';

export interface DropdownItem {
  site_id: string;
  site_name: string;
  selected: boolean;
  short_code: string;
}

// ---- New sidemenu API types ----
export interface MenuLeaf {
  url: string;
  icon?: string;
  category: string; // comma-separated e.g. "all site,single site"
  is_view: boolean;
  is_add: boolean;
  is_edit: boolean;
  id:string
}
export interface RawMenuNode {
  url?: string;
  icon?: string;
  [key: string]: any;
}
function isLeaf(node: any): node is MenuLeaf {
  return !!node && typeof node === 'object' && 'url' in node && 'category' in node;
}
const MENU_META_KEYS = new Set(['url', 'icon', 'api_url', 'category']);

@Component({
    selector: 'app-sidebar',
    imports: [CommonModule, NgbModule, FeathericonComponent, RouterModule, TranslateModule,SvgIconComponent,NgbTooltip,FormsModule,ScrollingModule],
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent {
  add_Edit:boolean = environment.add_edit
  mode: any;
  modeGrid: any;
  ReadingUnit: string | null;

trackBySiteId(_: number, item: any) {
  return item.site_id;
}
// Prefers the icon coming from the API response for this node; falls back
// to the existing NAME_ICON lookup table if the API doesn't supply one
// (empty string, null, or missing).
private resolveIcon(key: string, apiIcon: any): string {
  if (apiIcon && typeof apiIcon === 'string' && apiIcon.trim()) {
    return apiIcon;
  }
  return this.iconItems[key] || '';
}
search$ = new Subject<string>();
localStorageSiteId:string = ''

  public menuItems :any[]=[];
  private iconItems = this.navServices.NAME_ICON
  public menu: Menu[] = [];
  
  public margin: number = 0;
  public width: number = window.innerWidth;
  public leftArrowNone: boolean = true;
  public rightArrowNone: boolean = false;
  public screenWidth!: number;
  public screenHeight!: number;
  public pined: boolean = false;
  public pinedItem: number[] = [];
  selectedCityIds: string[] = [];

  public searchTerm: string = '';
  public readonly dropdownButtonText: string = 'Sites';

  basicdropdownitem: DropdownItem[] = [];
  siteid:'Y'|'N'|string = 'N'

  constructor(public router:Router,public navServices: NavmenuService, public layout: LayoutService,private apiService:ApiCallsService,private route:ActivatedRoute) 
  {
    if(window.innerWidth < 1400){
      this.navServices.closeSidebar = true;
    }

  }

  selectedSite: DropdownItem | null = null;

getsitelist() {
  const storedData = localStorage.getItem('siteList');
  
  this.apiService.getSiteList(this.localStorageSiteId||'').subscribe(data => {
    const list = data?.Data?.list || [];
    if (this.localStorageSiteId && this.localStorageSiteId !== 'ALL') {
      this.basicdropdownitem = list
        .sort((a: any, b: any) =>
          a.site_name.localeCompare(b.site_name)
        );
    } else {
      this.basicdropdownitem = [
        { site_name: 'All Sites', site_id: 'ALL' },
        ...list
          .sort((a: any, b: any) =>
            a.site_name.localeCompare(b.site_name)
          )
      ];
    }


    // ✅ IMPORTANT: initialize filteredItems here
    this.filteredItems = this.basicdropdownitem;

    if (storedData !== "") {
      localStorage.setItem('siteList', JSON.stringify(this.basicdropdownitem));
      localStorage.setItem('siteHeader',JSON.stringify(data?.Data?.header))
    }

    if (this.siteId && this.siteId !=='ALL') {
      let reading = this.setReadingUnit(this.siteId) || ''
      localStorage.setItem('ReadingUnit',reading)
      this.layout.showkwh(true)
      console.log('Unit: '+reading);
      const matchedSite =
        this.basicdropdownitem.find(
          item => String(item.site_id) === String(this.siteId)
        ) || this.basicdropdownitem[0];
      this.selectedSite = matchedSite;
    }
    else{
      console.log('showingfalse');
      
      this.layout.showkwh(false)
    }

  });
}
setReadingUnit(siteId: string|null) {
  const siteList = JSON.parse(localStorage.getItem('siteList') || '[]');
  const siteHeader = JSON.parse(localStorage.getItem('siteHeader') || '[]');

  if (!siteList.length || !siteHeader.length) return;
  let ReadingUnit: string =''
  const site = siteList.find((s: any) => String(s.site_id) === String(siteId));
  if (!site) 
    { ReadingUnit =''
      return};

  const readingKey = site.reading_unit;

  const header = siteHeader.find((h: any) => h.key ==='reading_unit');

  if (header?.MapByKey && readingKey in header.MapByKey) {
    ReadingUnit = header.MapByKey[readingKey];
  }
  else{ReadingUnit = readingKey}

  return ReadingUnit
}

filteredItems: DropdownItem[] = [];
onSearch(term: string) {
  this.searchTerm = term;
  const lower = term.toLowerCase().trim();

  if (!lower) {
    this.filteredItems = this.basicdropdownitem || [];
  } else {
    this.filteredItems = (this.basicdropdownitem || []).filter(item => {
      const siteName = item.site_name?.toLowerCase() || '';
      const shortCode = item.short_code?.toLowerCase() || '';
      
      return (
        siteName.includes(lower) ||
        shortCode.includes(lower)
      );
    });
  }
}


    goToEditSite(event: Event, site_id: string) {
    event.stopPropagation(); // prevents triggering parent <a> click
    const id = btoa(site_id)
    this.router.navigate(['/editsites'], { queryParams: { id } })
      .then(() => {
        window.location.reload();
      });
    }
  siteId:string |null= ''
  encodedId:string =''

selectSite(item: any): void {
  this.selectedSite = item;
  this.siteid = 'Y'
  sessionStorage.setItem('SiteName',item.site_name)
  const readingunit = this.setReadingUnit(item.site_id) || ''
  console.log('Unit: '+readingunit);
  
  localStorage.setItem('ReadingUnit',readingunit)

  const position = this.getQueryParamPosition('siteid');

  if ((item.site_id === 'ALL' || !item.site_id)) {
    this.encodedId = '';
    this.siteid = 'N'
    this.router.navigate(['/site_summary']);
    
    this.layout.showkwh(false)
    return;
  }

  this.layout.showkwh(true)
  this.encodedId = btoa(item.site_id.toString());
  this.apiService.getLocationList(item.site_id).subscribe(res=>{
  localStorage.removeItem('locationList')
            localStorage.setItem('locationList', JSON.stringify(res.Data));
            console.log(res);
            setTimeout(() => {
              this.router.navigate(
                ['/site_summary'],
                { queryParams: { siteid: this.encodedId } }
              );
            }, 100);
  })
}




    shouldShowNoSitesFound(): boolean {
    // Guard basicdropdownitem usage
    if (!this.basicdropdownitem || this.basicdropdownitem.length === 0) return false;
    const term = this.searchTerm.trim().toLowerCase();
    if (!term) return false;
    const matchExists = this.basicdropdownitem
      .filter(item => item.site_name !== 'Select All Sites')
      .some(it => it.site_name.toLowerCase().includes(term));
    return !matchExists;
  }

  shouldShowNoSitesAvailable(): boolean {
    // Guard basicdropdownitem usage
    if (!this.basicdropdownitem) return true; // If items haven't loaded, it can be considered "no sites available"
    return !this.searchTerm && this.basicdropdownitem.filter(it => it.site_name !== 'Select All Sites').length === 0;
  }

getValue(value: string): string {
  // 🔑 Special case: site summary for a single site
  if (value === 'Site Summary' && this.siteid === 'Y' && (this.logintype === 'AA' || this.logintype === 'DEV' || this.logintype === 'C')) {
    return '/site_summary';
  }

  return (
    '/' +
    value
      .toLowerCase()
      .replace(/[\s/-]+/g, '_')   // space, slash, or dash -> underscore
      .replace(/[^a-z0-9_]/g, '') // strip anything else
  );
}
SitenameProvide(siteid:string,sitename:string,sitecode:string){
  if (siteid != 'ALL') {
    return `${sitename} (${sitecode})`
  }
  else{
    return sitename
  }
}
public logintype :string | null = localStorage.getItem('login_Type')
replaceValue(value: any, map: any): any {
  if (!value || typeof value !== 'string') return value;

  let result = value;

  // replace DG (case insensitive)
  result = result.replace(/\bDG\b/gi, map['DG'] || 'DG');

  // replace GRID (case insensitive)
  result = result.replace(/\bGRID\b/gi, map['GRID'] || 'GRID');

  return result;
}
ngOnInit() {
  
  const textChange = JSON.parse(localStorage.getItem('textchange') || '{}');

  this.layout.message$.subscribe(res => {
    this.mode = this.replaceValue(res, textChange);
  });

  this.layout.messageGrid$.subscribe(res => {
    this.modeGrid = this.replaceValue(res, textChange);
  });
  this.layout.ShowKWH$.subscribe(res=>{
    if (res === true) {
      this.ReadingUnit = localStorage.getItem('ReadingUnit')
    }
    else{
      this.ReadingUnit = ''
    }
  })

  this.screenWidth = window.innerWidth;
  this.screenHeight = window.innerHeight;
  const encodedid  = localStorage.getItem('site_idLogin') || ''
  let decoded = 'ALL';
  try {
    decoded = encodedid ? atob(encodedid) : 'ALL';
  } catch {
    decoded = 'ALL';
  }
  this.siteId = decoded
  this.localStorageSiteId = decoded
      console.log(decoded);
  if (decoded ==='ALL') {
    this.handleQueryParams(); // 👈 MUST come first
  }
  else{
    this.encodedId = encodedid;
    this.siteid = 'Y';
    this.sidebarItems('Y');
    this.layout.showkwh(true);
  }
  
  this.search$
    .pipe(debounceTime(200), distinctUntilChanged())
    .subscribe(term => this.onSearch(term));
  this.listenToRouterChanges();
  this.getsitelist();

}


private handleQueryParams(): void {
  this.route.queryParamMap
    .pipe(
      map(params => {
        const position = this.getQueryParamPosition('siteid');
        const siteidParam = params.get('siteid');

        let decodedSiteId: string | null = null;
        if (siteidParam) {
          try {
            decodedSiteId = atob(decodeURIComponent(siteidParam));
          } catch {
            decodedSiteId = decodeURIComponent(siteidParam);
          }
        }

        // Single-site mode ONLY when siteid param exists, is not 'ALL', and is valid
        const isSingleSite = !!(siteidParam && decodedSiteId && decodedSiteId !== 'ALL' && position <= 0);

        return {
          siteid: isSingleSite ? decodeURIComponent(siteidParam!) : null,
          hasSiteId: isSingleSite ? 'Y' : 'N'
        };
      }),
      distinctUntilChanged(
        (a, b) =>
          a.siteid === b.siteid &&
          a.hasSiteId === b.hasSiteId
      )
    )
    .subscribe(({ siteid, hasSiteId }) => {
      this.setSiteFromQuery(siteid);      // ✅ actual siteid (or null)
      this.sidebarItems(hasSiteId);      // ✅ 'Y' or 'N'
    });
}
private setSiteFromQuery(siteid: string | null) {
  if (!siteid) {
    this.siteId = 'ALL';
    this.encodedId = '';
    this.selectedSite = this.basicdropdownitem.find(i => i.site_id === 'ALL') || null;
    this.layout.showkwh(false);
    return;
  }

  let decoded = '';
  try {
    decoded = atob(siteid);
  } catch {
    decoded = siteid;
  }

  this.siteId = decoded;

  if (decoded === 'ALL' || !decoded) {
    this.encodedId = '';
    this.selectedSite = this.basicdropdownitem.find(i => i.site_id === 'ALL') || null;
    this.layout.showkwh(false);
    return;
  }

  const readingunit = this.setReadingUnit(decoded) || '';
  console.log('Unit: ' + readingunit);

  localStorage.setItem('ReadingUnit', readingunit);
  this.layout.showkwh(true);
  this.encodedId = siteid;     // 🔑 CRITICAL
  this.selectedSite = this.basicdropdownitem.find(i => i.site_id === decoded) || null;
}

sidebarLoading:boolean = false;

// ---- Category matching for new sidemenu API ----
// Categories are, as of now: "All Site" and "Single Site" (compared lowercase).
// All-site mode ('N')   -> only items tagged "all site" are shown.
// Single-site mode ('Y') -> items tagged "single site" OR "all site" are shown.
// Recursively collects the config of every visible leaf under `node`
// (depth first), rather than stopping at the first match — so a submodule
// collapsed from multiple inner modules (e.g. "Site Configuration" ->
// "Tower Details" + "Unit Type") carries all of them, not just one.
private allVisibleLeafConfigs(node: RawMenuNode, siteMode: 'Y' | 'N' | string): any[] {
  const configs: any[] = [];
  for (const key in node) {
    if (MENU_META_KEYS.has(key)) continue; // skip group's own url/icon/api_url/category
    const value = node[key];
    if (isLeaf(value)) {
      if (value.is_view && this.matchesCategory(value.category, siteMode)) {
        configs.push({
          title: key,
          url: value.url,
          icon: value.icon,
          api_url: (value as any).api_url,
          category: value.category,
          is_view: value.is_view,
          is_add: value.is_add,
          is_edit: value.is_edit,
          id: value.id
        });
      }
    } else {
      configs.push(...this.allVisibleLeafConfigs(value as RawMenuNode, siteMode));
    }
  }
  return configs;
}

private getCategoryTypeIds(): { allSite: string | null; singleSite: string | null; roleCategoryTypes: Set<string> } {
  const roleCategories = JSON.parse(localStorage.getItem('role_categories') || '[]');

  let allSite: string | null = null;
  let singleSite: string | null = null;
  const roleCategoryTypes = new Set<string>();

  roleCategories.forEach((rc: any) => {
    const name = String(rc.name || rc._id || '').toLowerCase().trim();
    const typeId = String(rc.category_type);

    roleCategoryTypes.add(typeId); // every category this role has, regardless of name

    if (name === 'multi site' || name === 'all site') {
      allSite = typeId;
    } else if (name === 'single site') {
      singleSite = typeId;
    }
  });

  return { allSite, singleSite, roleCategoryTypes };
}

private matchesCategory(itemCategory: string, siteMode: 'Y' | 'N' | string): boolean {
  if (!itemCategory) return true;

  const { allSite, singleSite, roleCategoryTypes } = this.getCategoryTypeIds();
  const cats = itemCategory.toString().toLowerCase().split(',').map(c => c.trim()).filter(Boolean);
  if (!cats.length) return true;

  return cats.some(cat => {
    // "All Site" category — visible in both modes (as before), only if the role actually has it
    if (allSite && cat === allSite) return true;

    // "Single Site" category — visible only in single-site mode (as before)
    if (singleSite && cat === singleSite) return siteMode === 'Y';

    // Any other category (user-specific "3", or anything added in future) —
    // purely permission-based: visible whenever the role has been granted
    // this category_type, independent of siteMode.
    return roleCategoryTypes.has(cat);
  });
}

private joinRoute(parentRoute: string, segment: string): string {
  const cleanParent = parentRoute.replace(/\/+$/, '');   // strip trailing slash(es)
  const cleanSegment = segment.replace(/^\/+/, '');       // strip leading slash(es)
  return `${cleanParent}/${cleanSegment}`;
}

// ---- Recursively build the menu tree from the new nested API shape ----
// `parentRoute` accumulates as we descend so a submodule's route is prefixed
// with its parent group's route (e.g. "Reports" -> "Recharge Report" becomes
// "/reports/recharge_report" instead of just "/recharge_report").
private buildMenuTree(list: RawMenuNode, siteMode: 'Y' | 'N' | string, level: number = 1, parentRoute: string = ''): any[] {
  const nodes: any[] = [];
  let index = 0;
  for (const key in list) {
    if (MENU_META_KEYS.has(key)) continue; // skip this node's own url/icon/api_url/category
    const value = list[key];

    if (isLeaf(value)) {
      if (!value.is_view) continue;
      if (!this.matchesCategory(value.category, siteMode)) continue;
      const segment = value.url && value.url.trim() ? value.url : this.getValue(key);
      const route = this.joinRoute(parentRoute, segment);
      nodes.push({
        id: index++,
        level,
        title: key,
        icon: this.resolveIcon(key, value.icon),
        type: level === 1 ? 'sub' : 'link',
        active: false,
        path: {
          route,
          query: { siteid: this.encodedId }
        },
        children: [],
        config: [{
          title: key,
          url: value.url,
          icon: value.icon,
          api_url: (value as any).api_url,
          category: value.category,
          is_view: value.is_view,
          is_add: value.is_add,
          is_edit: value.is_edit,
          id: value.id
        }]
      });
    } else {
      // Group node: it may carry its own url/icon as sibling props now.
      const nodeApiUrl: string | undefined = (value as any).url;
      const nodeApiIcon: string | undefined = (value as any).icon;
      const groupSegment = nodeApiUrl && nodeApiUrl.trim() ? nodeApiUrl : this.getValue(key);
      const groupRoute = this.joinRoute(parentRoute, groupSegment);
      // Fallback route kept exactly as before, in case joinRoute-based
      // route ever needs to be compared/logged against the old behavior.
      const fallbackRoute = parentRoute + this.getValue(key);

      if (level >= 2) {
        const innerConfigs = this.allVisibleLeafConfigs(value as RawMenuNode, siteMode);
        if (!innerConfigs.length) continue;
        const innerUrls = [...new Set(
          innerConfigs.map(c => c.url).filter((u: string) => !!u && u.trim())
        )];
        // Prefer the group's own API url if given; otherwise fall back to
        // the old behavior of using a single common child url, or the
        // title-derived slug.
        const segment = nodeApiUrl && nodeApiUrl.trim()
          ? nodeApiUrl
          : (innerUrls.length === 1 ? innerUrls[0] : this.getValue(key));
        const route = this.joinRoute(parentRoute, segment);
        nodes.push({
          id: index++,
          level,
          title: key,
          icon: this.resolveIcon(key, nodeApiIcon),
          type: 'link',
          active: false,
          path: {
            route,
            query: { siteid: this.encodedId }
          },
          children: [],
          config: innerConfigs
        });
        continue;
      }

      const children = this.buildMenuTree(value as RawMenuNode, siteMode, level + 1, groupRoute || fallbackRoute);
      if (!children.length) continue; // drop empty groups after filtering
      nodes.push({
        id: index++,
        level,
        title: key,
        icon: this.resolveIcon(key, nodeApiIcon),
        type: 'sub',
        active: false,
        path: {
          route: groupRoute || fallbackRoute,
          query: { siteid: this.encodedId }
        },
        children
      });
    }
  }
  console.log(nodes)
  return nodes;
}
sidebarItems(siteid: 'Y' | 'N' | string = 'N') {
  this.siteid = siteid;
  this.sidebarLoading = true;

  this.apiService.getSideMenu().subscribe(data => {
    localStorage.setItem('sideMenuList', JSON.stringify(data.Data.list));

    const menuNav: any[] = [];
    menuNav.push({ headTitle1: '' });
    menuNav.push(...this.buildMenuTree(data.Data.list, siteid));

    this.menuItems = menuNav;
    this.sidebarLoading = false;

    // 🔑 whole tree, keyed by URL structure, not by "last thing clicked"
    localStorage.setItem('sidebarItems', JSON.stringify(this.menuItems));
    this.navServices.sidebarItemsUpdated$.next(); // tell app.component it can resolve now

    setTimeout(() => {
      this.setActiveMenuOnLoad(this.router.url);
    });
  });
}


  
listenToRouterChanges() {
  this.router.events.subscribe((event) => {
    if (event instanceof NavigationEnd) {
      this.setActiveMenuOnLoad(event.urlAfterRedirects);
    }
  });
}
setActiveMenuOnLoad(url: string) {
  if (!this.menuItems?.length) return;

  this.menuItems.forEach((item: any) => {
    if (url.startsWith(item.path?.route)) {
      this.setNavActive(item);
    }

    item.children?.forEach((child: any) => {
      if (url.startsWith(child.path?.route)) {
        this.setNavActive(child);
      }
    });
  });
}



  setNavActive(item: any) {
    this.menuItems.filter(menuItem => {
      if (menuItem !== item) {
        menuItem.active = false;
      }
      if (menuItem.children && menuItem.children.includes(item)) {
        menuItem.active = true;
      }
      if (menuItem.children) {
        menuItem.children.filter((submenuItems:any) => {
          if (submenuItems.children && submenuItems.children.includes(item)) {
            menuItem.active = true;
            submenuItems.active = true;
          }
          else {
            submenuItems.active = false;
          }
        });
      }
    });
  }

  openMenu() {
    this.navServices.closeSidebar = !this.navServices.closeSidebar;
  }

  // Called on click of any leaf sidebar menu item (module or submodule level).
  // `item.config` is always an array (one entry for a plain leaf, one entry
  // per visible inner module for a collapsed submodule). Group/header nodes
  // have no `config`, so this is a no-op for them.
  // onMenuItemClick(item: any): void {
  //   if (!item?.config) return;
  //   console.log(item);
    
  //   localStorage.setItem('SideComponentConfig', JSON.stringify(item.config));
  // }

  // For Horizontal Menu

  scrollToLeft() {
    if (this.margin >= -this.width) {
      this.margin = 0;
      this.leftArrowNone = true;
      this.rightArrowNone = false;
    } else {
      this.margin += this.width;
      this.rightArrowNone = false;
    }
  }

  scrollToRight() {
    if (this.margin <= -3500) {
      this.margin = -3000;
      this.leftArrowNone = false;
      this.rightArrowNone = true;
    } else {
      this.margin += -this.width;
      this.leftArrowNone = false;
    }
  }
  


  toggleMenu(item: Menu) {
    if (!item.active) {
      this.menuItems.forEach((a: Menu) => {
        if (this.menuItems.includes(item)) {
          a.active = false;
        }
        if (!a.children) {
          return false;
        }
        a.children.forEach((b: Menu) => {
          if (a.children?.includes(item)) {
            b.active = false;
          }
        });
        return;
      });
    }
    item.active = !item.active;
  }


  isPined(itemid: number) {
    return this.pinedItem.includes(itemid);
  }
private getQueryParamPosition(key: string): number {
  const query = this.router.url.split('?')[1];
  if (!query) return -1;

  return query
    .split('&')
    .findIndex(p => p.startsWith(`${key}=`));
}

  togglePined(id: number): void {
    const index = this.pinedItem.indexOf(id);
    if (index !== -1) {
      this.pinedItem.splice(index, 1);
    } else {
      this.pinedItem.push(id);
    }
    if (this.pinedItem.length <= 0) {
      this.pined = false;
    } else {
      this.pined = true;
    }
  }

}